import React, { Component } from 'react';
import { connect } from 'react-redux';

import { promptFeedback } from '../actions';

const mapStateToProps = (state) => {
    return({
        voteDict: state.convo.meta.voteDict
    });
}

class VoteBox extends Component {
    constructor(props) {
        super(props);
        this.promptFeedback = this.promptFeedback.bind(this);
    }

    promptFeedback(event) {
        console.log("triggered prompt feedback");
        this.props.dispatch(promptFeedback());
    }

    render() {
        Object.keys(this.props.voteDict).forEach(function(key) {
            console.log(key, this.props.voteDict[key]);
        });                

        return(
            <div>
                <iframe src="https://docs.google.com/forms/d/e/1FAIpQLScukoqXSgVYpJjF_Q1ARlvVGQUAv7SSvrJ-skxkPgkE1macUA/viewform?embedded=true" width="100%" height="500" frameborder="0" marginheight="0" marginwidth="0">Loading...</iframe>
                <br></br>
                <h2>After you vote...</h2>
                <button onClick={this.promptFeedback}>Click here to give us feedback!</button>
            </div>
        );
    }
}

export default connect(mapStateToProps)(VoteBox);


// WEBPACK FOOTER //
// ./src/components/VoteBox.js